import React, { useState } from 'react';

interface ReviewRequestModalProps {
  requestId?: string;
}

const ReviewRequestModal: React.FC<ReviewRequestModalProps> = ({ requestId }) => {
  const [reviewData, setReviewData] = useState({
    approvalStatus: '',
    comments: '',
    expectedDate: '',
    priority: 'medium'
  });

  // Mock request data - replace with API call
  const mockRequest = {
    requestId: 'REQ-2024-001',
    studentName: 'John Smith',
    studentId: 'STU-2024-123',
    documentType: 'Transfer Certificate',
    requestDate: '2024-12-20',
    reason: 'Family relocation to another state',
    urgency: 'High',
    supportingDocs: ['birth_certificate.pdf', 'parent_letter.pdf']
  };

  const handleApprove = () => {
    // TODO: Approve request API call
    console.log('Approving request:', requestId, reviewData);
  };

  const handleReject = () => {
    // TODO: Reject request API call  
    console.log('Rejecting request:', requestId, reviewData);
  };

  return (
    <div className="modal fade" id="reviewRequestModal">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Review Document Request</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div className="modal-body">
            {/* Request Details */}
            <div className="card mb-4">
              <div className="card-header">
                <h6 className="mb-0">Request Information</h6>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <p><strong>Request ID:</strong> {mockRequest.requestId}</p>
                    <p><strong>Student:</strong> {mockRequest.studentName}</p>
                    <p><strong>Student ID:</strong> {mockRequest.studentId}</p>
                  </div>
                  <div className="col-md-6">
                    <p><strong>Document Type:</strong> {mockRequest.documentType}</p>
                    <p><strong>Request Date:</strong> {mockRequest.requestDate}</p>
                    <p><strong>Urgency:</strong> <span className="badge bg-danger">{mockRequest.urgency}</span></p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <p><strong>Reason:</strong></p>
                    <p className="text-muted">{mockRequest.reason}</p>
                  </div>
                </div>
                {mockRequest.supportingDocs.length > 0 && (
                  <div className="row">
                    <div className="col-12">
                      <p><strong>Supporting Documents:</strong></p>
                      <div className="d-flex gap-2 flex-wrap">
                        {mockRequest.supportingDocs.map((doc, index) => (
                          <button key={index} className="btn btn-outline-primary btn-sm">
                            <i className="ti ti-download me-1"></i>{doc}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Review Form */}
            <form>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Expected Completion Date</label>
                  <input 
                    type="date" 
                    className="form-control"
                    value={reviewData.expectedDate}
                    onChange={(e) => setReviewData({...reviewData, expectedDate: e.target.value})}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Priority Level</label>
                  <select 
                    className="form-select"
                    value={reviewData.priority}
                    onChange={(e) => setReviewData({...reviewData, priority: e.target.value})}
                  >
                    <option value="low">Low</option>
                    <option value="medium">Medium</option>
                    <option value="high">High</option>
                    <option value="urgent">Urgent</option>
                  </select>
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Review Comments</label>
                <textarea 
                  className="form-control"
                  rows={4}
                  value={reviewData.comments}
                  onChange={(e) => setReviewData({...reviewData, comments: e.target.value})}
                  placeholder="Add any comments or instructions..."
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Additional Requirements</label>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="parentSignature" />
                  <label className="form-check-label" htmlFor="parentSignature">
                    Requires parent signature
                  </label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="feePayment" />
                  <label className="form-check-label" htmlFor="feePayment">
                    Fee payment required
                  </label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="notifyParent" />
                  <label className="form-check-label" htmlFor="notifyParent">
                    Send notification to parent
                  </label>
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              Close
            </button>
            <button 
              type="button" 
              className="btn btn-danger me-2"
              onClick={handleReject}
              data-bs-toggle="modal"
              data-bs-target="#rejectRequestModal"
            >
              <i className="ti ti-x me-2"></i>Reject
            </button>
            <button type="button" className="btn btn-success" onClick={handleApprove}>
              <i className="ti ti-check me-2"></i>Approve
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewRequestModal;
